"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCalculatedColumnSchema = function (column) {
    return column.calculation !== undefined;
};
exports.isTableCalcRef = function (calc) {
    return calc !== undefined && calc.type === 'table-calc';
};
exports.isTimeShiftRef = function (calc) {
    return exports.isTableCalcRef(calc) && calc.tableCalcType === 'time-shift';
};
exports.isRowShiftRef = function (calc) {
    return exports.isTableCalcRef(calc) && calc.tableCalcType === 'row-shift';
};
exports.isDateTimeColumnSchema = function (column) {
    return column !== undefined && column.type === 'datetime';
};
exports.columnSchemaForRef = function (definition, ref) {
    return definition.schema[ref.column];
};
var constantEffectiveDefinition = {
    schema: {
        measure: {
            type: 'number'
        },
        timestamp: {
            type: 'datetime'
        },
        color: {
            type: 'string'
        },
        comparisonMeasure: {
            type: 'number'
        },
        comparisonTimestamp: {
            type: 'datetime'
        },
    },
    features: {
        color: {
            column: 'color',
        },
        measure: { column: 'measure' },
        timestamp: { column: 'timestamp' },
        comparison: [
            {
                measure: { column: 'comparisonMeasure' },
                timestamp: { column: 'comparisonTimestamp' },
            },
        ],
    },
    tableTransforms: {},
};
exports.getConstantEffectiveDefinition = function () {
    return constantEffectiveDefinition;
};
//# sourceMappingURL=EffectiveDefinition.js.map